import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Space } from "antd";
import { AppState } from "store";
import { setModalName, setSelectedServiceCentre } from "store/actions";
import { editIcon, deleteIcon } from "svgs";
import { ServiceCentresState } from "types";
import DropdownAction from "./dropdown-action";

export function ActionMenu(
  value: string,
  row: {
    raw: ServiceCentresState["selectedServiceCentre"];
  }
) {
  const dispatch = useDispatch();

  const {
    common: { userType = 1 },
  } = useSelector<AppState, AppState>((state) => state);

  const onEditServiceCentre = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation(); // Prevent row click
      e.preventDefault();
      dispatch(setSelectedServiceCentre(row.raw));
      dispatch(setModalName("edit_service_centre"));
    },
    [dispatch, row.raw]
  );

  const onDeleteServiceCentre = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation(); // Prevent row click
      e.preventDefault();
      dispatch(setSelectedServiceCentre(row.raw));
      dispatch(setModalName("delete_service_centre"));
    },
    [dispatch, row.raw]
  );

  // Don't render anything for userType 6
  if (userType === 6) {
    return null;
  }

  return (
    <div
      className="action-menu-container"
      onClick={(e) => e.stopPropagation()}
    >
      <Space size={16} className="action-icons">
     <span className="edit-icon icon" onClick={onEditServiceCentre}>
{editIcon}
</span>

        {/* Dropdown Action (Delete, etc.) */}
        <DropdownAction serviceCentre={row.raw} />
      </Space>
    </div>
  );
}